import { makeStyles } from '@material-ui/core';

export const useReviseOwnershipModalStyles = makeStyles(theme => ({
  // ==================== Dialog Styles ====================
  dialogPaper: {
    minWidth: 800,
    maxWidth: 1000,
  },
  dialogTitle: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(2),
  },
  titleText: {
    fontSize: 20,
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  dialogContent: {
    padding: theme.spacing(3),
  },
  description: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1.5),
    lineHeight: 1.5,
  },
  errorBox: {
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    backgroundColor: '#ffebee',
    color: '#c62828',
    borderRadius: 4,
    border: '1px solid #ef5350',
  },
  errorText: {
    fontSize: 14,
    fontWeight: 500,
  },
  optionsInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.action.hover,
    borderRadius: 6,
    border: `1px solid ${theme.palette.divider}`,
  },
  optionItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  optionLabel: {
    fontSize: 13,
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: 1.5,
  },
  optionDescription: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
    paddingLeft: theme.spacing(0.5),
  },

  // ==================== Table Styles ====================
  tableContainer: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 6,
    overflow: 'hidden',
    marginBottom: theme.spacing(3),
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  tableHeader: {
    backgroundColor: theme.palette.action.hover,
  },
  tableHeaderCell: {
    padding: theme.spacing(1.5, 2),
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textAlign: 'left',
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  tableRow: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  tableCell: {
    padding: theme.spacing(2),
    fontSize: 13,
    color: theme.palette.text.primary,
    verticalAlign: 'top',
  },

  // ==================== Repository Cell Styles ====================
  repositoryInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  repositoryName: {
    fontSize: 13,
    fontWeight: 600,
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  repositoryLink: {
    fontSize: 12,
    color: theme.palette.primary.main,
    fontFamily: 'monospace',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  currentTeam: {
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: 4,
    backgroundColor: theme.palette.action.hover,
    fontSize: 12,
    fontWeight: 500,
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.divider}`,
  },

  // ==================== Controls/Form Styles ====================
  controlsCell: {
    minWidth: 400,
  },
  controlsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  teamSelectContainer: {
    flex: 1,
    minWidth: 240,
  },
  checkboxContainer: {
    flexShrink: 0,
  },
  checkboxLabel: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
  },

  // ==================== Actions/Button Styles ====================
  dialogActions: {
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2, 3),
    display: 'flex',
    justifyContent: 'space-between',
  },
  actionsLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  actionsRight: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  submitButton: {
    textTransform: 'none',
    fontSize: 13,
    fontWeight: 600,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: '8px 24px',
    borderRadius: 6,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  cancelButton: {
    textTransform: 'none',
    fontSize: 13,
    fontWeight: 500,
    color: theme.palette.text.secondary,
    padding: '8px 20px',
    borderRadius: 6,
  },
  selectionInfo: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },

  // ==================== Remove Button Styles ====================
  removeButton: {
    color: theme.palette.text.secondary,
    padding: theme.spacing(0.5),
    '&:hover': {
      color: theme.palette.error.main,
      backgroundColor: theme.palette.action.hover,
    },
  },
  removeIconCell: {
    width: 50,
    textAlign: 'center',
  },
}));
